<section class="services-products-section">
  <div class="container">
    <div class="section-title text-center mb-5">
      <div class="sparkles-icon mb-3">
        <img
          src="assets/img/sparkles.svg"
          alt="Sparkles"
          class="img-fluid"
          width="40"
        />
      </div>
      <p class="text-muted mb-2">
        {{ "translations.newArrivals_subtitle" | translate }}
      </p>
      <h2 class="display-4 fw-bold">
        {{ "translations.newArrivals" | translate }}
      </h2>
    </div>

    <div class="row g-4">
      <div class="col-lg-4 col-md-6" *ngFor="let product of products">
        <div class="card h-100 border-0 shadow-sm hover-elevation">
          <div class="position-relative">
            <img
              [src]="
                product.photoPath
                  ? apiURL + product.photoPath
                  : 'assets/img/placeholder.png'
              "
              [alt]="product.name"
              class="card-img-top"
              style="object-fit: cover; height: 300px"
                   [routerLink]="['/item', { id: product.inItemID}]"
            
            />

            <button
              class="btn btn-dark rounded-circle position-absolute cart-btn"
              style="right: 15px; bottom: 15px"
            >
              <fa-icon [icon]="faShoppingCart" (click)="addToCart(product)" />
            </button>
          </div>

          <div class="card-body text-center">
            <h3 class="h5 card-title mb-3">
              {{ currentLang === "ar" ? product.nameAr : product.name }}
            </h3>
            @if(product.activateWebDiscount){
            <p class="h6 fw-bold mb-0 text-decoration-line-through">
              {{ product.salesPrice }} {{ "translations.currency" | translate }}
            </p>
            <h4>
              {{
                (product?.webDiscountAmount || 0)
              }}
              {{ "translations.currency" | translate }}
            </h4>

            } @else {
            <h4>
              {{ product.salesPrice }} {{ "translations.currency" | translate }}
            </h4>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
